import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector, useAppDispatch } from '../hooks';
import { DeviceButton2 } from '../components/DeviceButton';
import { transmitter } from '../actions/Transmitter';
import { isTransmitterDeviceState } from '../reducers/device_states';
export const DeviceButtonsNexaOnOff = props => {
    const devices = useAppSelector(state => state.definitions.devices);
    const device_states = useAppSelector(state => state.device_states);
    const dispatch = useAppDispatch();
    const device = devices[props.device_id];
    if (device == undefined) {
        return null;
    }
    const s = device_states[props.device_id];
    const state = isTransmitterDeviceState(s) ? s['state'] : undefined;
    let s1, s2;
    if (state == 'on') {
        s1 = undefined;
        s2 = 'on';
    }
    else if (state == 'off') {
        s1 = 'off';
        s2 = undefined;
    }
    else {
        s1 = undefined;
        s2 = undefined;
    }
    return (_jsxs("div", { className: "transmitter-buttons lw-button-group", children: [_jsx(DeviceButton2, { state: s1, onClick: () => dispatch(transmitter(props.device_id, 'off')), children: "Av" }), _jsx(DeviceButton2, { state: s2, onClick: () => dispatch(transmitter(props.device_id, 'on')), children: "P\u00E5" })] }));
};
